// useValidationRules.ts
import {useMemo} from "react";
import {BaseFormComponent} from "../DynamicFormTypes.ts";
import {useFormMethods, useFormStatic} from "../DyanmicFormContext.tsx";
import {ValidationFactory} from "../ValidationFactory.ts";

interface UseValidationRulesProps {
    component: BaseFormComponent;
}

export const useValidationRules = ({ component }: UseValidationRulesProps) => {
    const { formMethods } = useFormMethods();
    const { metaData, flattenedSchemaMap, customValidator } = useFormStatic();

    return useMemo(() => {
        const schemaComponent = flattenedSchemaMap.get(component.fieldKey);

        const componentWithRules = component.validationRules
            ? component
            : {
                ...component,
                validationRules: schemaComponent?.validationRules ?? component.validationRules
            };

        return ValidationFactory.createValidationRules(
            componentWithRules,
            metaData,
            formMethods,
            flattenedSchemaMap,
            customValidator
        );
    }, [
        component.fieldKey,
        component.validationRules, // Only re-create if rules change
    ]);
};